import { ToggleProps } from './index'
import styles from './styles.module.scss'

const ToggleLabeled = ({
  labelA,
  labelB,
  toggled,
  labelDir = 'right',
  onToggle,
  classes = ''
}: ToggleProps) => {
  const containerClass = [
    styles.Toggle,
    styles.labeled,
    styles[labelDir],
    toggled ? styles.on : styles.off,
    classes
  ]
    .filter(Boolean)
    .join(' ')

  const currentLabel = toggled ? labelB : labelA

  return (
    <div className={containerClass}>
      {currentLabel && (
        <span
          className={`${styles.Toggle__label} ${toggled ? styles.active : ''}`}
        >
          {currentLabel}
        </span>
      )}
      <button
        className={`${styles.Toggle__button}  ${toggled ? styles.active : ''}`}
        onClick={onToggle}
      >
        <span className={styles.Toggle__slider} />
      </button>
    </div>
  )
}

export default ToggleLabeled
